export const ADD_MODEL = 'ADD_MODEL'
export const DELETE_MODEL = 'DELETE_MODEL'
export const ADD_RPOP_NAME = 'ADD_RPOP_NAME'
export const JUST_ADD_PROP = 'JUST_ADD_PROP'
export const REMOVE_ALL_RPOPS = 'REMOVE_ALL_RPOPS'
export const EDIT_PROP = 'EDIT_PROP'
export const DELETE_PROP = 'DELETE_PROP'
export const ADD_RELATION = 'ADD_RELATION'
export const REMOVE_RELATION = 'REMOVE_RELATION'
export const UPDATE_AMOUNT = 'UPDATE_AMOUNT'
export const ENABLE_AUTH = 'ENABLE_AUTH'
export const DISABLE_AUTH = 'DISABLE_AUTH'
export const SET_PROGRESS = 'SET_PROGRESS'
export const SET_LOCALE = 'SET_LOCALE'
export const TOGGLE_BUILDER = 'TOGGLE_BUILDER'
